import React, { useState, useEffect } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth, sendEmailVerification } from 'firebase/auth';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { showToast } from '../utils/toast';
import ConfirmationModal from './ConfirmationModal';

function AddTenantModal({ show, onClose }) {
    // Estados do formulário
    const [tenantName, setTenantName] = useState('');
    const [reportEmail, setReportEmail] = useState('');
    const [reportWhatsapp, setReportWhatsapp] = useState('');
    
    // Estados de controle do fluxo
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [consentUrl, setConsentUrl] = useState('');
    const [showEmailConfirm, setShowEmailConfirm] = useState(false);

    useEffect(() => {
        if (!show) {
            setTimeout(() => {
                setTenantName('');
                setReportEmail('');
                setReportWhatsapp('');
                setConsentUrl('');
                setIsSubmitting(false);
            }, 200);
        }
    }, [show]);

    const handleResendEmailVerification = async () => {
        const auth = getAuth();
        if (auth.currentUser) {
            try {
                await sendEmailVerification(auth.currentUser);
                showToast('success', 'E-mail de verificação enviado!');
            } catch (err) {
                console.error("Erro ao reenviar e-mail:", err);
                showToast('error', 'Não foi possível reenviar o e-mail.');
            }
        }
        setShowEmailConfirm(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const functions = getFunctions();
            const createTenant = httpsCallable(functions, 'create_tenant');

            const payload = {
                tenantName: tenantName,
                reportEmail: reportEmail,
                reportWhatsapp: reportWhatsapp,
            };

            const result = await createTenant(payload);
            setConsentUrl(result.data.consentUrl);
            
        } catch (error) {
            console.error("Erro ao chamar a função create_tenant:", error);
            
            if (error.code === 'functions/failed-precondition') {
                setShowEmailConfirm(true);
            } else {
                showToast('error', `Operação Falhou: ${error.message}`);
                onClose(); 
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    // ALTERAÇÃO: A função agora apenas copia e fecha.
    const handleCopyAndClose = () => {
        if (consentUrl) {
            navigator.clipboard.writeText(consentUrl)
                .then(() => showToast('success', 'Link copiado!'))
                .catch(() => showToast('error', 'Falha ao copiar o link.'));
        }
        onClose();
    };

    // NOVA FUNÇÃO: Para abrir o link na mesma aba.
    const handleOpenLink = () => {
        if(consentUrl) {
            window.location.href = consentUrl;
        }
    };

    return (
        <>
            <Modal show={show} onHide={onClose} centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {consentUrl ? 'Link de Convite Gerado!' : 'Gerar Link de Onboarding'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {consentUrl ? (
                        <div>
                            <p className="text-start">Envie o seguinte link para o administrador do tenant aprovar a integração. O tenant já foi pré-cadastrado e aguarda a autorização.</p>
                            <InputGroup className="mt-3">
                                <Form.Control
                                    value={consentUrl}
                                    readOnly
                                />
                            </InputGroup>
                        </div>
                    ) : (
                        <Form onSubmit={handleSubmit}>
                            <p className="small text-muted">Preencha os dados abaixo. As informações serão salvas e associadas ao tenant após o consentimento do administrador.</p>
                            <div className="form-floating mb-3">
                                <input type="text" className="form-control" id="tenantName" value={tenantName} onChange={(e) => setTenantName(e.target.value)} placeholder="Nome do Tenant" required />
                                <label htmlFor="tenantName">Nome do Tenant (Ex: Empresa XYZ)</label>
                            </div>
                            <div className="form-floating mb-3">
                                <input type="email" className="form-control" id="reportEmail" value={reportEmail} onChange={(e) => setReportEmail(e.target.value)} placeholder="E-mail para relatórios" required />
                                <label htmlFor="reportEmail">E-mail para envio de relatórios</label>
                            </div>
                            <div className="form-floating mb-3">
                                <input type="text" className="form-control" id="reportWhatsapp" value={reportWhatsapp} onChange={(e) => setReportWhatsapp(e.target.value)} placeholder="WhatsApp para notificações" />
                                <label htmlFor="reportWhatsapp">WhatsApp para notificações (Ex: +5511...)</label>
                            </div>
                        </Form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {consentUrl ? (
                        // ALTERAÇÃO: Novos botões aqui.
                        <>
                            <Button variant="secondary" onClick={handleCopyAndClose}>
                                Copiar link de convite
                            </Button>
                            <Button variant="primary" onClick={handleOpenLink}>
                                Abrir link
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                                {isSubmitting ? 'Gerando...' : 'Gerar Link'}
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>

            <ConfirmationModal
                show={showEmailConfirm}
                onHide={() => setShowEmailConfirm(false)}
                onConfirm={handleResendEmailVerification}
                title="Verificação de E-mail Necessária"
                body="Para adicionar um novo tenant, você precisa primeiro confirmar seu endereço de e-mail. Deseja reenviar o e-mail de verificação?"
                confirmText="Reenviar E-mail"
                confirmVariant="primary"
            />
        </>
    );
}

export default AddTenantModal;